import i18n from '@/locales'
import dayjs from 'dayjs'

/**
 * 防抖函数，首次执行
 * @param {*} fn
 * @param {*} delay
 * @returns
 */
let timer = null
export function debounce(fn, delay = 500) {
  return function() {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.call(this)
      clearTimeout(timer)
    }, delay)
  }
}

/**
 * 获取error message
 * @param {*} status 
 * @returns 
 */
export function getErrorMsg(status) {
  return (i18n.te(`errorCode.${status}`) && i18n.t(`errorCode.${status}`)) ? i18n.t(`errorCode.${status}`) : `Error: Error Code ${status}`
}


/**
 * 两个日期，如果月份相同返回单个月份，如果月份不同返回两个
 * @param {*} date1 
 * @param {*} date2 
 */
export function formatSameMonth(date1, date2, connectSymbol='-', symbol='-') {
  if (!date1 || !date2) {
    return `${date1}${connectSymbol}${date2}`
  }
  const m1 = dayjs(date1).format(`YYYY${symbol}MM`)
  const m2 = dayjs(date2).format(`YYYY${symbol}MM`)
  if (m1 === m2) {
    return m1
  } else {
    return `${m1}${connectSymbol}${m2}`
  }
}

/**
 * 获取ProdMid
 * @param {*} val 
 * @returns 
 */
export function getProdMid(val) {
  let prodMid = ''
  if (/product/.test(val) && val.split('/product/')[1]) {
    prodMid = val.split('/product/')[1].split('-')[0]
  } else if (/cruises/.test(val) && val.split('/cruises/')[1]) {
    prodMid = val.split('/cruises/')[1].split('-')[0]
  } else {
    prodMid = ''
  }
  prodMid = prodMid.split('?')[0]
  prodMid = prodMid.split('/')[0]
  // prodMid长度1-8位，不能以0开头
  if(prodMid.length > 8 || parseInt(prodMid).toString() != prodMid){
    prodMid = ''
  }
  return prodMid
}

/**
 * 获取地区显示字符串
 * @param {*} country 
 * @param {*} maxEllipsis 
 * @returns 
 */
export function getLocationStr(country, maxEllipsis = 0) {
    let location = []
    if (country.length > 0) {
        for (let i = 0; i < country.length; i++) {
            if (location.indexOf(country[i].name) == -1) {
                location.push(country[i].name)
            }
            if (country[i].cities && country[i].cities.length > 0) {
                for (let k = 0; k < country[i].cities.length; k++) {
                    if (location.indexOf(country[i].cities[k].name) == -1) {
                        location.push(country[i].cities[k].name)
                    }
                }
            }
        }
    }
    
    // 超出数量省略的阈值
    if (maxEllipsis > 0 && location.length > maxEllipsis) {
        location = location.slice(0, maxEllipsis)
    }
    return location.length > 0 ? location.toString() : ''
}

/**
 * 用于将一个对象序列化成一个字符串，这样就可以将对象作为查询字符串添加到 URL 中
 * @param {*} data 
 * @param {*} traditional 
 * @returns 
 */
export function param(data, traditional) {
    var params = []
    traditional = traditional || false
 
    function recurse(obj, key) {
        if (Array.isArray(obj)) {
            obj.forEach(function (v, i) {
                recurse(v, traditional ? key : key + '[' + (traditional ? i : '') + ']')
            })
        } else if (typeof obj === 'object') {
            for (var subkey in obj) {
                if (obj.hasOwnProperty(subkey)) {
                    recurse(obj[subkey], traditional ? key : key + '[' + subkey + ']')
                }
            }
        } else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj))
        }
    }
 
    for (var key in data) {
        if (data.hasOwnProperty(key)) {
            recurse(data[key], key)
        }
    }
 
    return params.join('&').replace(/%20/g, '+')
}

